import { render, staticRenderFns } from "./WildNext.vue?vue&type=template&id=49c88b60&scoped=true"
import script from "./WildNext.vue?vue&type=script&lang=js"
export * from "./WildNext.vue?vue&type=script&lang=js"
import style0 from "./WildNext.vue?vue&type=style&index=0&id=49c88b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c88b60",
  null
  
)

export default component.exports